import '../scss/Bannerbar.scss';

import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { route } from 'preact-router';
import { PATH } from './constant';

import KaiAd from './lib/kaiads.min.js';

class BannerBar extends PureComponent {
  constructor(props) {
    super();
    this.publisher = '2dddcb68-d226-49a0-bb99-c65e141088e8';
    this.adNavCls = 'ad-nav';
    this.adSize = [210, 54];
  }

  state = {
    currentIndex: 0,
    isFocus: false
  };

  // Get a responsive Ad via KaiAds SDK
  fetchOneKaiAd(index) {
    return new Promise((resolve, reject) => {
      KaiAd({
        publisher: this.publisher,
        app: 'KaiStore',
        slot: 'Banner Bar',
        h: this.adSize[1],
        w: this.adSize[0],
        // 1 when testing the ad, 0 when in production
        test: 0,
        container: document.getElementById(`ad-${index}`),
        onerror: err => {
          console.error('Custom catch:', err);
          reject(err);
        },
        onready: ad => {
          ad.call('display', {
            tabindex: 1,
            navClass: this.adNavCls,
            display: 'inline-block'
          });
          resolve();
        }
      });
    });
  }

  fetchManyKaiAds() {
    let promises = [];

    for (let i = 0; i < this.props.itemNum; i++) {
      promises.push(this.fetchOneKaiAd(i));
    }

    Promise.all(promises).then(
      () => {
        // All resovled: show the banner
        this.element.classList.remove(...this.element.classList);
      },
      () => {
        // Any rejected: remove all banner items
        const indicators = this.element.querySelector('.indicator-bar');
        const banners = this.element.querySelector('.banner-bar');
        this.element.removeChild(indicators);
        this.element.removeChild(banners);
      }
    );
  }

  getAppId(manifestURL) {
    const partitions = manifestURL.split('/');
    const len = partitions.length;

    return partitions[len - 1];
  }

  getAdInfo(ad, key) {
    return new Promise((resolve, reject) => {
      ad.on(key, value => {
        ad.info[key] = value;
        resolve();
      });
      ad.call(key);
    });
  }

  componentDidMount() {
    this.element.addEventListener('keydown', this.handleKeydown.bind(this));
    this.element.addEventListener('focus', this.handleFocus.bind(this));
    // Fetch KaiAds and put them on banners.
    this.fetchManyKaiAds();
  }

  handleKeydown(e) {
    switch (e.key) {
      case 'ArrowDown':
        // banner blur and focus on apps-view
        this._blur();
        this.props.blur();
        break;
      case 'ArrowRight':
        this._nav(1, e);
        break;
      case 'ArrowLeft':
        this._nav(-1, e);
        break;
      case 'Enter':
      case 'ArrowUp':
      case 'BrowserBack':
      case 'Accept':
      default:
        // do nothing, pass to parent.
        break;
    }
  }

  _nav(move, e) {
    const length = this.props.itemNum;
    let currentIndex = this.state.currentIndex;

    if ('rtl' === document.dir) {
      move = move * -1;
    }
    currentIndex += move;
    if (currentIndex < -0) {
      currentIndex = length - 1;
    } else {
      currentIndex %= length;
    }
    // deactive the item
    this._blur(true);
    // change the current index, and active the selected item
    this.setState({ currentIndex: currentIndex }, () => {
      this._focus();
    });

    e.preventDefault();
  }

  handleFocus(e) {
    this._focus();
  }

  _focus() {
    let idx = this.state.currentIndex;
    let bar = this.element.querySelector('.banner-bar');
    let containers = this.element.querySelectorAll('.ad-item');
    let indicators = this.element.querySelector('.indicators');
    let ads = this.element.querySelectorAll(`.${this.adNavCls}`);
    let dots = this.element.querySelectorAll('.indicators > li');
    let offset = -1 * ((210 + 7) * idx) + 11 - 4;

    if (!this.state.isFocus) {
      this.setState({ isFocus: true });
    }

    bar.style.transform = 'translateX(' + offset + 'px)';
    containers[idx].classList.add('ad-item', 'active');
    indicators.classList.add('indicators', 'active');
    ads[idx].focus();
    dots[idx].classList.add('active');
  }

  _blur(isChangeBanner) {
    let bar = this.element.querySelector('.banner-bar');
    let container = this.element.querySelector('.ad-item.active');
    let indicators = this.element.querySelector('.indicators.active');
    let dot = this.element.querySelector('.indicators > li.active');
    let offset = -1 * ((210 + 7) * this.state.currentIndex) + 11;

    if (this.state.isFocus) {
      this.setState({ isFocus: false });
    }

    bar.style.transform = 'translateX(' + offset + 'px)';
    container.classList.add('ad-item');
    indicators.classList.add('indicators');
    if (isChangeBanner) {
      dot.classList.remove(...dot.classList);
      indicators.classList.add('active');
    }
  }

  render() {
    const componentId = this.props['data-id'];
    const PREFIX_AD = 'ad';
    const PREFIX_INDICATE = 'dot';
    let ads = [];
    let dots = [];

    for (let i = 0; i < this.props.itemNum; i++) {
      ads.push(
        <li key={PREFIX_AD + '-' + i}>
          <span
            id={PREFIX_AD + '-' + i}
            className={
              this.state.isFocus && i === this.state.currentIndex
                ? 'ad-item active'
                : 'ad-item'
            }
          />
        </li>
      );
      dots.push(
        <li
          key={PREFIX_INDICATE + '-' + i}
          className={i === this.state.currentIndex ? 'active' : ''}
        />
      );
    }

    return (
      <div
        id={componentId}
        className="hidden"
        tabIndex="1"
        ref={element => {
          this.element = element;
        }}
      >
        <div className="indicator-bar">
          <ol className="indicators">{dots}</ol>
        </div>
        <div className="banner-bar" tabIndex="1">
          <ul>{ads}</ul>
        </div>
      </div>
    );
  }
}

export default BannerBar;



/** WEBPACK FOOTER **
 ** ./src/Bannerbar.js
 **/